import Grid from "@mui/material/Grid";
import { PageLayout } from "./components/PageLayout";
import { Routes, Route } from "react-router-dom";

import { Home } from "./pages/Home";
import { CaseDevelopment } from "./pages/CaseDevelopment";
import { CaseDate } from "./pages/CaseDate";
import { CaseDocuments } from "./pages/CaseDocuments";
import { PersonnelChange } from "./pages/PersonnelChange";
import { RequestForApproval } from "./pages/RequestForApproval";
import { PersonnelRate } from "./pages/PersonnelRate";
import { Success } from "./pages/Success";
import { RequestForRemoval } from "./pages/RequestForRemoval";
//MSAL
import {
  MsalProvider,
  useIsAuthenticated,
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsalAuthentication,
} from "@azure/msal-react";

import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import {
  InteractionRequiredAuthError,
  InteractionType,
} from "@azure/msal-browser";
import { ImportInvoice } from "./pages/ImportInvoice";

import './App.css';

function App({ msalInstance }) {
  const isAuthenticated = useIsAuthenticated();
  const request = {
    loginHint: "name@example.com",
    scopes: ["User.Read"],
  };

  const { inProgress } = useMsal();
  const { login, result, error } = useMsalAuthentication(
    InteractionType.Silent,
    request
  );

  useEffect(() => {
    if (error) {
      login(InteractionType.Popup, request);
    }
  }, [error]);


  return (
    <MsalProvider instance={msalInstance}>
      <PageLayout>
        <Grid container justifyContent="center">
          <Pages />
        </Grid>
      </PageLayout>
    </MsalProvider>
  );
}

const Pages = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/CaseDate" element={<CaseDate />} />
      <Route path="/CaseDevelopment" element={<CaseDevelopment />} />
      <Route path="/CaseDocuments" element={<CaseDocuments />} />
      <Route path="/ImportInvoice" element={<ImportInvoice/>} />
      <Route path="/PersonnelChange" element={<PersonnelChange />} />
      <Route path="/PersonnelRate" element = {<PersonnelRate/>} />
      <Route path="/RequestForApproval" element={<RequestForApproval />} />
      <Route path="/RequestForRemoval" element={<RequestForRemoval />} />
      <Route path="/Success" element={<Success />} />
    </Routes>
    
  );
};


export default App;
